<div
  class="flex animate-pulse cursor-default items-start gap-3 border-b border-gray-200 bg-white p-4 px-2">
  <!-- Email Content -->
  <div class="min-w-0 flex-1">
    <div class="flex flex-col gap-1">
      <!-- Header Row -->
      <div class="mb-1 flex w-full items-start justify-between">
        <div class="mb-2 flex items-center gap-2">
          <!-- Avatar Skeleton -->
          <div class="h-8 w-8 rounded-full bg-gray-200"></div>

          <!-- Sender Name and Metadata -->
          <div class="flex flex-col gap-1">
            <!-- Sender Name Skeleton -->
            <div class="h-3 w-32 rounded bg-gray-200"></div>

            <!-- Attachments Row Skeleton -->
            <div class="flex items-center gap-4">
              <div class="h-3 w-24 rounded bg-gray-200"></div>
            </div>
          </div>
        </div>

        <!-- Timestamp Skeleton -->
        <div class="flex flex-shrink-0 items-center gap-2">
          <div class="h-3 w-16 rounded bg-gray-200"></div>
        </div>
      </div>
    </div>

    <!-- Subject Skeleton -->
    <div class="mb-1 h-3 w-3/4 rounded bg-gray-200"></div>

    <!-- Preview Text Skeleton -->
    <div class="h-3 w-full rounded bg-gray-200"></div>
  </div>
</div>
